"use client";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useRef, useState } from "react";
export function useGeolocation(_a, callback, isEnabled) {
    var _b = _a === void 0 ? {} : _a, enableHighAccuracy = _b.enableHighAccuracy, maximumAge = _b.maximumAge, timeout = _b.timeout;
    if (isEnabled === void 0) { isEnabled = false; }
    var _c = __read(useState({}), 2), state = _c[0], setState = _c[1];
    var watchID = useRef();
    var updateCoordinates = useCallback(function (_a) {
        var coords = _a.coords, timestamp = _a.timestamp;
        setState({
            coords: coords,
            isLoading: false,
        });
        if (typeof callback === "function") {
            callback(coords);
        }
    }, [callback]);
    var setError = useCallback(function (error) {
        setState({
            error: error,
            isLoading: false,
        });
    }, []);
    var getCurrentPosition = useCallback(function () {
        return new Promise(function (resolve, reject) {
            if (navigator.geolocation) {
                setState({
                    isLoading: true,
                });
                navigator.geolocation.getCurrentPosition(updateCoordinates, setError);
                watchID.current = navigator.geolocation.watchPosition(function (geoLocationPosition) {
                    updateCoordinates(geoLocationPosition);
                    resolve(geoLocationPosition);
                }, function (error) {
                    setError(error);
                    reject(error);
                }, {
                    enableHighAccuracy: enableHighAccuracy,
                    maximumAge: maximumAge,
                    timeout: timeout,
                });
            }
            else {
                reject();
            }
        });
    }, [enableHighAccuracy, maximumAge, setError, timeout, updateCoordinates]);
    useEffect(function () {
        if (isEnabled) {
            getCurrentPosition();
        }
        return function () {
            if (watchID.current) {
                navigator.geolocation.clearWatch(watchID.current);
            }
        };
    }, [isEnabled]);
    return [state, getCurrentPosition];
}
